<div
  [class.active]="isOpenMobileMenu"
  class="mobile-menu">
  <div class="mobile-menu__head">
    <img
      src="assets/img/logo.svg"
      alt="logo"
      class="mobile-menu__head-logo" />
    <button
      (click)="closeMobileMenu()"
      class="mobile-menu__head-close-btn">
      <img
        src="assets/img/close.svg"
        alt="Close btn"
        class="icon" />
    </button>
  </div>
  <div class="mobile-menu__body">
    <app-navigation></app-navigation>
  </div>
</div>
